export default __webpack_public_path__ + "static/media/carte-dioptic-allowed-sro.52ab003e.png";